import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { DashboardState, SchoolDashboardResponse } from '../types';
import { SchoolDashboardAreaSearchResponse } from '../types/SchoolDashboardAreaSearchResponse';

const initialState: DashboardState = {
  dashboard: undefined!,
  dashboardAreaSearch: undefined!,
  usingDashboard: null,
  forceOldDashboard: false,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardAction(state, action: PayloadAction<SchoolDashboardResponse>) {
      state.dashboard = action.payload;
    },

    setDashboardAreaSearchAction(state, action: PayloadAction<SchoolDashboardAreaSearchResponse>) {
      state.dashboardAreaSearch = action.payload;
    },

    setDashboardUsingAction(state, action: PayloadAction<boolean | null>) {
      state.usingDashboard = action.payload;
    },

    setDashboardForceOldDashboardAction(state, action: PayloadAction<boolean>) {
      state.forceOldDashboard = action.payload;
    },
  },
});

export const { setDashboardAction, setDashboardAreaSearchAction, setDashboardUsingAction, setDashboardForceOldDashboardAction } =
  dashboardSlice.actions;

export const getDashboard = (state: RootState): DashboardState => state.dashboard;

export default dashboardSlice.reducer;
